import { isPlatformBrowser } from "@angular/common";
import { Directive, ElementRef, EventEmitter, OnDestroy, AfterViewInit, Output, input, Inject, PLATFORM_ID } from "@angular/core";

@Directive({
    selector: '[inView]',
    standalone: true
})
export class InViewDirective implements AfterViewInit, OnDestroy {
    readonly inViewThreshold = input(0.3);
    readonly inViewRepeat = input(false);

    @Output() inView = new EventEmitter<void>();

    private observer: IntersectionObserver | null = null;

    constructor(
        private el: ElementRef<HTMLElement>,
        @Inject(PLATFORM_ID) private platformId: any
    ) { }

    ngAfterViewInit(): void {
        if (!isPlatformBrowser(this.platformId)) return;

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.inView.emit();
                        if (!this.inViewRepeat()) {
                            this.observer?.unobserve(this.el.nativeElement);
                        }
                    }
                })
            },
            { threshold: this.inViewThreshold() }
        );

        this.observer.observe(this.el.nativeElement);
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }
}
